<template>
    <vs-popup class="gopos-ordr-detail update-price-popup create-custom-item-popup" title="Customized Item" :active.sync="popupConfig.isOpen">
        <div class="flex align-center mb-5">
            <p class="mr-5">Amount:</p>
            <!-- <p>${{ custom_item.price || 0 }}</p> -->
            <vs-input v-model="custom_item.price" class="w-full" v-on:keypress="isNumber($event)" />
        </div>
        <div class="flex align-center mb-12">
            <p class="mr-base" :class="{'pb-6 mb-1': name_error}">Name: </p>
            <vs-input v-validate="'required'" name="name" :danger="name_error" danger-text="Name is required" class="w-full" v-model="custom_item.name" @input="name_error = false" />
        </div>
        <div class="flex-center">
            <vs-button type="border" class="w-1/3 mr-4" @click="popupConfig.isOpen = false">CANCEL</vs-button>
            <vs-button class="w-1/3" @click="saveResult">OK</vs-button>
        </div>
        <!-- <update-price-popup :item_data="custom_item" :popupConfig="addPriceConfig" :isAddPrice="true" @returnPrice="getPrice"></update-price-popup> -->
    </vs-popup>
</template>

<script>
export default {
    name: "create-custom-item-popup",
    props: {
        popupConfig: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            custom_item: { price: 0, name: "" },
            addPriceConfig: { isOpen: false },
            name_error: false
        }
    },
    watch: {
        popupConfig: {
            immediate: true,
            deep: true,
            handler() {
                if(this.popupConfig.isOpen) {
                    this.custom_item.price = 0;
                    this.custom_item.name = "";
                    this.name_error = false;
                    // this.addPriceConfig.isOpen = true;
                }
            }
        }
    },
    methods: {
        isNumber: function(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if (((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) || (charCode == 46 && this.custom_item.price.toString().indexOf(".") != -1) ||
            ((charCode >= 48 && charCode <= 57) && this.custom_item.price.toString().indexOf(".") != -1 && (this.custom_item.price.toString().substring(this.custom_item.price.toString().indexOf(".") + 1)).length == 2)) {
                evt.preventDefault();
            } else {
                if (charCode == 46) {
                    if(this.custom_item.price == "") {
                        this.custom_item.price = 0;
                    }
                } else if (this.custom_item.price === 0 || this.custom_item.price === '0') {
                    this.custom_item.price = "";
                }
                return true;
            }
        },
        // getPrice(price) {
        //     this.custom_item.price = price;
        //     this.addPriceConfig.isOpen = false;
        // },
        saveResult() {
            if(this.custom_item.name != "") {
                this.$emit("getCustomItem", this.custom_item);
                this.popupConfig.isOpen = false;
            } else {
                this.name_error = true;
            }
        }
    }
}
</script>

<style lang="scss">
.create-custom-item-popup {
    &.con-vs-popup {
        z-index: 53000;
        .vs-popup {
            width: 380px;
        }
    }
}
</style>